import type { ApiErrorResponse } from "../@api/apiError";
import { mapErrorCodeToCopyKey } from "../@api/apiError";
import {
  isNewUserResponse,
  mapTunnistusResponseToState,
  tunnistusPost,
} from "../@api/tunnistus";
import type { History } from "history";
import { getHideNavigation } from "../store/hideNavigation/hideNavigation";
import { getIsWeb, getRedirectState } from "../@api/config";
import { getWithoutSearch, isPasswordResetReturnPath } from "../utils/location";
import { routes } from "../utils/routes";
import {
  authRedirect,
  setErrorCopyKey,
  setTermsAccepted,
  setVerificationValues,
} from "../store/auth";
import { isUserTooYoung } from "../utils/isUserTooYoung";
import type { AppDispatch } from "../store/configureStore";

export async function handleStrongAuthReturn(
  dispatch: AppDispatch,
  history: History,
  location: Location,
  code: string,
  acr_values: string,
  terms_accepted: boolean,
): Promise<boolean> {
  try {
    // call tunnistus endpoint to verify tunnistus code
    const tunnistusResponse = await tunnistusPost(
      code,
      getWithoutSearch(location),
      acr_values,
    );
    const isMobile = getHideNavigation() || !getIsWeb();

    // save tunnistus values to store
    dispatch(
      setVerificationValues(
        mapTunnistusResponseToState(tunnistusResponse),
      ),
    );
    dispatch(setTermsAccepted(terms_accepted));

    if (isPasswordResetReturnPath(location)) {
      if (tunnistusResponse.new_user) {
        // password reset without account
        history.replace(routes.SIGNUP);
        dispatch(
          setErrorCopyKey([
            "signup_error__password_change_without_account",
          ]),
        );
      } else {
        history.replace(routes.PASSWORD_RESET_FORM);
      }
    } else if (isUserTooYoung(tunnistusResponse.receiver_ssn)) {
      // redirect user to too young page
      history.replace(routes.SIGNUP_TOO_YOUNG);
    } else if (isNewUserResponse(tunnistusResponse)) {
      history.replace(routes.SIGNUP_FORM_V2);
    } else if (isMobile) {
      // login directly
      const { resource_owner, access_token } = tunnistusResponse;
      const state = getRedirectState();
      dispatch(
        authRedirect({
          resource_owner,
          access_token,
          state,
        }),
      );
      // return true to avoid rendering anything with react
      return true;
    } else {
      // This handles completions
      history.replace(routes.VERIFICATIONS);
    }
  } catch (error) {
    const codeError = error as ApiErrorResponse;
    const errorMessage = mapErrorCodeToCopyKey(codeError.code);
    if (errorMessage) {
      dispatch(setErrorCopyKey(errorMessage));
    }
    history.replace(routes.ROOT);
  }
  // make sure to return false for all other cases
  // login directly is only case when we don't want to render anything
  return false;
}
